import type { ReactElement, Severity } from './types';

import styles from './styles.module.scss';

// 14×14 viewBox shape primitives per severity (chip container renders at 13×13).
// Shapes use `currentColor` so the per-severity CSS class drives stroke/fill;
// `prohibited` is the one two-color variant with a white diagonal slash.
export const ICON_BY_SEVERITY: Record<Severity, ReactElement> = {
    advisory: <polygon fill='currentColor' points='7,1.4 12.6,7 7,12.6 1.4,7' />,
    critical: (
        <>
            <circle cx='7' cy='7' fill='none' r='5.8' stroke='currentColor' strokeWidth='1.6' />

            <line stroke='currentColor' strokeWidth='1.6' x1='3.2' x2='10.8' y1='10.8' y2='3.2' />
        </>
    ),
    info: (
        <>
            <circle cx='7' cy='7' fill='none' r='5.8' stroke='currentColor' strokeWidth='1.6' />

            <circle cx='7' cy='4.2' fill='currentColor' r='0.8' />

            <line
                stroke='currentColor'
                strokeLinecap='round'
                strokeWidth='1.6'
                x1='7'
                x2='7'
                y1='6.2'
                y2='10.2'
            />
        </>
    ),
    prohibited: (
        <>
            <circle cx='7' cy='7' fill='currentColor' r='5.8' />

            <line
                className={styles.slash}
                strokeLinecap='round'
                strokeWidth='1.6'
                x1='3.5'
                x2='10.5'
                y1='10.5'
                y2='3.5'
            />
        </>
    ),
    safe: (
        <>
            <circle cx='7' cy='7' fill='none' r='5.8' stroke='currentColor' strokeWidth='1.6' />

            <path
                d='M 3.8 7.4 L 6.2 9.4 L 10.2 4.6'
                fill='none'
                stroke='currentColor'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='1.6'
            />
        </>
    ),
    warning: (
        <>
            <path
                d='M 7 1.6 L 12.8 12.2 L 1.2 12.2 Z'
                fill='none'
                stroke='currentColor'
                strokeLinejoin='round'
                strokeWidth='1.6'
            />

            <line
                stroke='currentColor'
                strokeLinecap='round'
                strokeWidth='1.6'
                x1='7'
                x2='7'
                y1='5.6'
                y2='8.6'
            />

            <circle cx='7' cy='10.4' fill='currentColor' r='0.75' />
        </>
    )
};
